module.exports = __webpack_public_path__ + "static/media/logo1.aaf59a1d.svg";